import React from 'react';
import {ListPaginationHttpResponse} from '@src/@types/components/List';
import Translate from '@src/components/Translate/Translate';
import Pagination from '@src/components/Pagination/Pagination';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';

export default function TotalPriceOfList(props: ListPaginationHttpResponse) {
    let totalPrice: number | null = null;
    if (Pagination.isPaginationResponse(props)) {
        totalPrice = props.total_price ?? null;
    }

    if (totalPrice == null) {
        return null;
    }

    return <div className="d-flex align-items-center">
        <div className="me-1">
            <Translate message="OrdersIndex.total-price-of-orders-list"/>:
        </div>
        <div>
            <FormattedPrice amount={totalPrice}/>
        </div>
    </div>;
}
